import { Component, effect, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { LoadService } from 'src/app/core/services/load.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { BancolombiaServiceService } from 'src/app/shared/bc-connect/services/bancolombia-service.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';

@Component({
  selector: 'app-recommendations-modal',
  imports: [],
  templateUrl: './recommendations-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './recommendations-modal.component.scss',
})
export class RecommendationsModalComponent implements OnInit {
  isLoading = false;

  constructor(
    public load: LoadService,
    private bancolombiaService: BancolombiaServiceService,
    private sesion: SesionService,
    private router: Router,
    private offerService: OfferService,
    private dataLayerService: DataLayersService
  ) {
    effect(() => {
      if (this.bancolombiaService.validateTrigger() > 0) {
        this.sendModalApplication();
        this.customersValidate();
      }
    });
  }

  ngOnInit(): void { }

  private sendModalApplication(): void {
    const offer = this.offerService.offerSelected;
    this.dataLayerService.dl_eventoGA4_modal_application(
      offer?.card?.productName ?? '',
      String(offer?.offerId ?? ''),
      offer?.company?.name ?? '',
      DataLayersService.getOfferIsFeatured(offer?.labelType ?? '0'),
      DataLayersService.getOfferLabel(offer?.labelType ?? '0', offer?.textLabel ?? '')
    );
  }

  customersValidate(): void {
    this.isLoading = true;
    this.bancolombiaService.customersValidate({ sessionId: this.sesion.sesionCookie })
      .subscribe({
        next: (response: any) => {
          if (response?.data?.validate.trim().toUpperCase() === 'SUCCESS' || response?.data?.validate.trim().toUpperCase() === 'PENDING') {
            this.bancolombiaService.validateResponse = response?.data;
          }
          this.isLoading = false;
          if (!this.bancolombiaService.validateResponse?.urlAuthenticate || this.bancolombiaService.validateResponse?.urlAuthenticate.trim() === '') {
            this.load.closeBancolombiaModal();
            this.bancolombiaService.validateError.set(true);
          }
        },
        error: (err: any) => {
          console.error('[RecommendationsModal] customersValidate error:', err);
          this.isLoading = false;
          this.load.closeBancolombiaModal();
          if (err?.status === 404) {
            this.bancolombiaService.creditDenied.set(true);
            return;
          }
          this.bancolombiaService.validateError.set(true);
        }
      });
  }

  cancel(): void {
    this.sendCancelApplication('Cancelar');
    this.bancolombiaService.fuaPopupRef?.close();
    this.offerService.clearOfferlocalStorage();
    this.load.closeBancolombiaModal();
    this.router.navigate(['/ofertas']);
  }

  private sendCancelApplication(buttonName: string): void {
    const offer = this.offerService.offerSelected;
    this.dataLayerService.dl_eventoGA4_cancel_application(
      offer?.card?.productName ?? localStorage.getItem('productName'),
      String(offer?.offerId ?? localStorage.getItem('offerId') ?? ''),
      offer?.company?.name ?? localStorage.getItem('companyName'),
      DataLayersService.getOfferIsFeatured(offer?.labelType ?? '0'),
      DataLayersService.getOfferLabel(offer?.labelType ?? '0', offer?.textLabel ?? ''),
      buttonName
    );
  }

  private sendConfirmApplication(): void {
    const offer = this.offerService.offerSelected;
    this.dataLayerService.dl_eventoGA4_confirm_application(
      offer?.card?.productName ?? localStorage.getItem('productName'),
      String(offer?.offerId ?? localStorage.getItem('offerId') ?? ''),
      offer?.company?.name ?? localStorage.getItem('companyName'),
      'Continuar',
      DataLayersService.getOfferIsFeatured(offer?.labelType ?? '0'),
      DataLayersService.getOfferLabel(offer?.labelType ?? '0', offer?.textLabel ?? '')
    );
  }

  // Se dispara al abrir el popup FUA de login externo Bancolombia
  private sendPartnerModalSso(): void {
    const offer = this.offerService.offerSelected;
    this.dataLayerService.dl_eventoGA4_partner_modal_sso(
      offer?.card?.productName ?? '',
      String(offer?.offerId ?? ''),
      offer?.company?.name ?? ''
    );
  }

  confirm(): void {
    const url = this.bancolombiaService.validateResponse?.urlAuthenticate;
    if (url) {
      this.sendConfirmApplication();
      this.sendPartnerModalSso();
      const isMobile = window.screen.width <= 768;
      let w: number, h: number, left: number, top: number;

      if (isMobile) {
        w = window.screen.width;
        h = window.screen.height;
        left = 0;
        top = 0;
      } else {
        const maxDesktopWidth = 700;
        const maxDesktopHeight = 500;
        const minWidth = 320;
        const minHeight = 460;
        w = Math.max(minWidth, Math.min(maxDesktopWidth, Math.floor(window.screen.width * 0.95)));
        h = Math.max(minHeight, Math.min(maxDesktopHeight, Math.floor(window.screen.height * 0.9)));
        left = Math.max(0, Math.round((window.screen.width - w) / 2));
        top = Math.max(0, Math.round((window.screen.height - h) / 2));
      }

      this.bancolombiaService.fuaPopupRef = window.open(
        url,
        'fuaAuthWindow',
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes`
      );
    }
    this.bancolombiaService.fuaConfirmed.set(true);
  }
}
